import { MatSnackBar } from '@angular/material/snack-bar';
import { Injectable } from '@angular/core';
import { couponInfoMap } from '../models/coupon-snack-bar.model';
import { Payment } from '../models/payment.model';

@Injectable({
  providedIn: 'root',
})
export class CouponInfoSnackBarService {
  constructor(private snackBar: MatSnackBar) {}

  public showCouponInfo(payment: Payment, redirectUrl = null): void {
    const { additionalData } = payment.couponInfo;

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const data = {
      billerName: additionalData?.billerName,
      username: additionalData?.username,
      billers: payment.unverifiedCustomerBillers.join(', '),
      cancelPaymentRedirectUrl: redirectUrl,
      paymentId: payment.id,
    };
    const couponDetails = couponInfoMap(payment.couponInfo.couponStatus);

    if (couponDetails && !this.snackBar._openedSnackBarRef) {
      // this.snackBar.openFromComponent(CouponSnackBarComponent, {
      //   data: { couponDetails, additionalData: data },
      // });
    }
  }

  public closeCouponInfo(): void {
    this.snackBar.dismiss();
  }
}
